import { Text } from "@smoothincorg/smooth-ui"
import React from "react"
import styled from "styled-components"

type ContainerProps = {
  height?: number
  text?: string | false
}

type Props = ContainerProps & {
  className?: string
}

const Component: React.FC<Props> = ({ height = 200, text, ...props }) => {
  return (
    <div className={props.className}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="/images/spinner.svg"
        style={{
          height,
          width: "auto",
        }}
        alt="loading"
      />
      {text !== false && <Text textAlign="center">Loading...</Text>}
    </div>
  )
}

const StyledComponent = styled(Component)`
  font-size: 1.8rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  flex-direction: column;

  > img {
    display: block;
    height: 200px;
    width: auto;
  }
`

const Container: React.FC<ContainerProps> = (props) => {
  return <StyledComponent {...props} />
}

export const PokeLoading = Container
